import React, { useEffect, useState, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
// Smooth scroll function with offset for fixed header
const smoothScroll = (e, targetId) => {
  e.preventDefault();
  const element = document.getElementById(targetId);
  if (element) {
    const headerOffset = 80; // Height of your fixed header
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

const Hero = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredSecondary, setIsHoveredSecondary] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  // Text gradient animation effect
  const gradientText = {
    background: 'linear-gradient(90deg, var(--primary-color), var(--secondary-color), var(--primary-color))',
    backgroundSize: '200% auto',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animation: 'gradient 8s linear infinite',
    display: 'inline-block',
    position: 'relative',
    zIndex: 1
  };

  return (
    <section className="position-relative overflow-hidden" style={{
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      padding: '100px 0',
      minHeight: '90vh',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden',
      borderBottom: '1px solid rgba(0,0,0,0.05)'
    }}>
      {/* Decorative gradient circles */}
      <div className="position-absolute" style={{
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(99, 102, 241, 0.08) 0%, rgba(99, 102, 241, 0) 70%)',
        top: '-300px',
        right: '-300px',
        zIndex: 0,
        animation: 'float 8s ease-in-out infinite'
      }}></div>
      
      <div className="position-absolute" style={{
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(59, 130, 246, 0.05) 0%, rgba(59, 130, 246, 0) 70%)',
        bottom: '-200px',
        left: '-100px',
        zIndex: 0,
        animation: 'float 10s ease-in-out 1s infinite reverse'
      }}></div>

      <div className="container position-relative" style={{ zIndex: 1 }}>
        <div className="row align-items-center">
          <div className="col-lg-6" data-aos="fade-right" data-aos-duration="800">
            <div className="d-inline-block px-3 py-1 rounded-pill mb-4" style={{ 
              background: 'rgba(99, 102, 241, 0.1)',
              border: '1px solid rgba(99, 102, 241, 0.2)'
            }}>
              <span className="text-primary fw-medium">⚡ Now with 2x faster speeds</span>
            </div>
            <h1 className="display-4 fw-bold mb-4" style={{ lineHeight: '1.2' }}>
              <span style={gradientText}>Lightning Fast</span>
              <br />
              <span className="text-dark">Internet for Your </span>
              <span className="text-primary">Home</span>
            </h1>
            <p className="lead mb-5" style={{ 
              fontSize: '1.25rem',
              color: '#4b5563',
              maxWidth: '90%',
              lineHeight: '1.6'
            }}>
              Experience <span className="fw-semibold">blazing-fast speeds</span> and <span className="fw-semibold">reliable connectivity</span> with our fiber-optic network. 
              Stream 4K content, game online, and work from home without buffering or interruptions.
            </p>
            
            <div className="d-flex flex-wrap gap-3 mb-5" data-aos="fade-up" data-aos-delay="100">
              <a
                href="#packages"
                onClick={(e) => smoothScroll(e, 'packages')}
                className="btn btn-primary btn-lg px-5 py-3 rounded-pill fw-medium position-relative overflow-hidden border-0 shadow-lg shadow-primary/20 hover-shadow-primary/30 transition-all duration-300"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                  background: 'linear-gradient(45deg, var(--primary-color), var(--secondary-color))',
                  transform: 'translateY(0)'
                }}
              >
                <span className="position-relative z-1 d-flex align-items-center">
                  View Packages <i className={`fas fa-arrow-right ms-2 transition-transform ${isHovered ? 'transform translate-x-1' : ''}`} />
                </span>
                <span 
                  className={`position-absolute top-0 start-0 w-full h-full bg-white/10 backdrop-blur-sm opacity-0 transition-all duration-300 ${isHovered ? 'opacity-100' : ''}`}
                  style={{ zIndex: 0 }}
                />
              </a>
              
              <a
                href="#contact"
                onClick={(e) => smoothScroll(e, 'contact')}
                className="btn btn-outline-primary btn-lg px-5 py-3 rounded-pill fw-medium position-relative overflow-hidden border-2"
                onMouseEnter={() => setIsHoveredSecondary(true)}
                onMouseLeave={() => setIsHoveredSecondary(false)}
                style={{
                  borderColor: 'var(--primary-color)',
                  background: 'transparent',
                  color: 'var(--primary-color)',
                  transition: 'all 0.3s ease'
                }}
              >
                <span className="position-relative z-1 d-flex align-items-center">
                  Get Started <i className={`fas fa-phone-alt ms-2 transition-transform ${isHoveredSecondary ? 'transform scale-110' : ''}`} />
                </span>
                <span 
                  className={`position-absolute top-0 start-0 w-0 h-full bg-primary/5 transition-all duration-300 ${isHoveredSecondary ? 'w-full' : 'w-0'}`}
                  style={{ zIndex: 0 }}
                />
              </a>
            </div>
            
            <div className="d-flex flex-wrap align-items-center gap-4 mt-4">
              <div className="d-flex align-items-center bg-white p-3 rounded-3 shadow-sm" style={{
                border: '1px solid rgba(0,0,0,0.05)'
              }}>
                <div className="d-flex me-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fas fa-star text-warning me-1" style={{ fontSize: '1.1rem' }}></i>
                  ))}
                </div>
                <div>
                  <div className="fw-semibold text-dark">4.9/5</div>
                  <div className="text-muted small">2,500+ reviews</div>
                </div>
              </div>
              
              <div className="d-flex align-items-center">
                <div className="position-relative me-3">
                  <img 
                    src="https://randomuser.me/api/portraits/women/32.jpg" 
                    alt="Customer" 
                    className="rounded-circle border border-3 border-white" 
                    style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                  />
                  <img 
                    src="https://randomuser.me/api/portraits/men/44.jpg" 
                    alt="Customer" 
                    className="rounded-circle border border-3 border-white" 
                    style={{ 
                      width: '40px', 
                      height: '40px', 
                      objectFit: 'cover',
                      position: 'absolute',
                      left: '20px',
                      zIndex: 1
                    }}
                  />
                </div>
                <div>
                  <div className="fw-semibold text-dark">10,000+</div>
                  <div className="text-muted small">Happy Customers</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1000">
            <div className="position-relative" style={{
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 32px 64px -12px rgba(0, 0, 0, 0.15)',
              transform: 'perspective(1200px) rotateY(-8deg) rotateX(2deg)',
              transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
              zIndex: 1,
              border: '1px solid rgba(255, 255, 255, 0.2)',
              height: '500px' // Fixed height for the container
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'perspective(1200px) rotateY(0deg) rotateX(0deg)';
              e.currentTarget.style.boxShadow = '0 40px 80px -15px rgba(99, 102, 241, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'perspective(1200px) rotateY(-8deg) rotateX(2deg)';
              e.currentTarget.style.boxShadow = '0 32px 64px -12px rgba(0, 0, 0, 0.15)';
            }}>
              <div style={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '16px',
                border: '1px solid rgba(0,0,0,0.05)',
                width: '100%',
                height: '100%',
                background: '#f0f4f8' // Fallback background color
              }}>
                <img 
                  src="/images/high-speed-internet.jpg" 
                  alt="High Speed Internet" 
                  className="position-absolute w-full h-full object-cover"
                  style={{
                    display: 'block',
                    transition: 'transform 1s cubic-bezier(0.16, 1, 0.3, 1)',
                    transform: 'scale(1.1)',
                    minHeight: '100%',
                    minWidth: '100%',
                    objectFit: 'cover'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1.1)';
                  }}
                  onError={(e) => {
                    // Fallback in case image fails to load
                    e.target.onerror = null;
                    e.target.src = '/images/optical-fiber2.jpg';
                  }}
                />
                <div className="position-absolute w-full h-full" style={{
                  top: 0,
                  left: 0,
                  background: 'linear-gradient(0deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.1) 40%)',
                  zIndex: 1
                }}></div>
              </div>
              
              {/* Floating feature cards */}
              <div className="position-absolute" style={{
                bottom: '30px',
                left: '30px',
                zIndex: 2
              }}>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center bg-white p-3 rounded-3" style={{
                    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
                    maxWidth: '280px',
                    backdropFilter: 'blur(10px)',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0,0,0,0.05)',
                    transform: 'translateX(-20px)',
                    opacity: 0,
                    animation: 'slideIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.3s forwards'
                  }}>
                    <div className="me-3" style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '1.25rem',
                      flexShrink: 0
                    }}>
                      <i className="fas fa-bolt"></i>
                    </div>
                    <div>
                      <div className="text-muted small">Blazing Fast</div>
                      <div className="h5 mb-0 fw-bold text-dark">Up to 1 Gbps</div>
                    </div>
                  </div>
                  
                  <div className="d-flex align-items-center bg-white p-3 rounded-3" style={{
                    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
                    maxWidth: '280px',
                    backdropFilter: 'blur(10px)',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0,0,0,0.05)',
                    transform: 'translateX(-20px)',
                    opacity: 0,
                    animation: 'slideIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.5s forwards'
                  }}>
                    <div className="me-3" style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, #10B981, #34D399)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '1.25rem',
                      flexShrink: 0
                    }}>
                      <i className="fas fa-shield-alt"></i>
                    </div>
                    <div>
                      <div className="text-muted small">Secure & Reliable</div>
                      <div className="h5 mb-0 fw-bold text-dark">99.9% Uptime</div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="position-absolute" style={{
                top: '30px',
                right: '30px',
                zIndex: 2
              }}>
                <div className="bg-white rounded-pill px-4 py-2 d-inline-flex align-items-center" style={{
                  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
                  backdropFilter: 'blur(10px)',
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  border: '1px solid rgba(0,0,0,0.05)',
                  transform: 'translateY(-10px)',
                  opacity: 0,
                  animation: 'fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.7s forwards'
                }}>
                  <div className="me-2" style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: '#10B981',
                    animation: 'pulse 2s infinite'
                  }}></div>
                  <span className="fw-medium text-dark">Available in your area</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Animated Background Elements */}
      <div className="hero-shape-1" style={{
        position: 'absolute',
        top: '10%',
        right: '5%',
        width: '300px',
        height: '300px',
        borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
        background: 'linear-gradient(45deg, rgba(0, 198, 255, 0.1), rgba(0, 114, 255, 0.2))',
        animation: 'morph 15s ease-in-out infinite',
        zIndex: -1
      }}></div>
      
      <div className="hero-shape-2" style={{
        position: 'absolute',
        bottom: '10%',
        left: '5%',
        width: '400px',
        height: '400px',
        borderRadius: '60% 40% 30% 70% / 60% 60% 40% 40%',
        background: 'linear-gradient(135deg, rgba(0, 198, 255, 0.1), rgba(0, 114, 255, 0.1))',
        animation: 'morph 18s ease-in-out infinite reverse',
        zIndex: -1
      }}></div>
      
      {/* Animated Grid Overlay */}
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{
        backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px)',
        backgroundSize: '40px 40px',
        zIndex: -1
      }}></div>
      <style jsx global>{`
        @keyframes backgroundMove {
          0% { background-position: 0 0; }
          100% { background-position: 100px 100px; }
        }
        
        @keyframes float {
          0% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(2deg); }
          100% { transform: translateY(0px) rotate(0deg); }
        }
        
        @keyframes slideIn {
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        
        @keyframes fadeInUp {
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes pulse {
          0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7); }
          70% { box-shadow: 0 0 0 8px rgba(16, 185, 129, 0); }
          100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
        }
        
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        
        @keyframes pulse {
          0% { transform: rotate(15deg) translateZ(60px) scale(1); }
          50% { transform: rotate(15deg) translateZ(60px) scale(1.1); }
          100% { transform: rotate(15deg) translateZ(60px) scale(1); }
        }
        
        .pulse-dot {
          animation: pulse 1.5s infinite;
        }
        
        .shadow-2xl {
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }
        
        .shadow-primary/20 {
          --tw-shadow-color: rgba(99, 102, 241, 0.2);
          --tw-shadow: var(--tw-shadow-colored);
        }
        
        .hover\:shadow-primary\/30:hover {
          --tw-shadow-color: rgba(99, 102, 241, 0.3);
          --tw-shadow: var(--tw-shadow-colored);
          box-shadow: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
        }
      `}</style>
    </section>
  );
};

export default Hero;
